export default {
    clients: [],
    clientsLoaded: false,
    commission: null,
    user: null,
    users: [],
    usersLoaded: false,
    signUpUser: {
        email: '',
        password: ''
    },
    qrCode: {
        qrCodeUrl: '',
        manualEntryCode: ''
    },
    clientInvitations: [],
    applicationInfo: {},
    partner: {},
    partnerTransactions: [],
    partnerTransactionsTotal: 0,
    partnerTransactionsLoading: false,
    partnerTransactionsSums: {}
};
